// extracted by mini-css-extract-plugin
module.exports = {"lia-action-delete-ban":"DeleteBanAction_lia-action-delete-ban__xJk1D"};